module.exports = __webpack_public_path__ + "media/images/green_tick-5b4d90a57eb25fe3441b4892db3e5ff9.svg";